"use client";

import { PayPalExpressCheckoutBase } from "../PayPalExpressCheckoutBase";

import { useCreateBasket } from "./useCreateBasket";

/** v1 wrapper: resolves the v1 (`forms-actions`) `createBasket` function and
 * forwards it to the version-agnostic `<PayPalExpressCheckoutBase>`. The hook
 * is unconditionally called here (Rules of Hooks) — only one of the V1/V2
 * wrappers is ever mounted at a time, picked by the parent dispatcher.
 *
 * Must be rendered inside a `<FlowProvider>` because `useCreateBasket` (v1)
 * reads `useFlow()` to source the `flowSlug` / product. Currently always the
 * case as it's mounted via the `paypal_express_checkout` form-service field. */
export function PayPalExpressCheckoutV1({
  price,
  onSuccess,
  onError,
  onAvailabilityChange,
}: Readonly<{
  price: number;
  onSuccess: () => void;
  onError: (message: string) => void;
  onAvailabilityChange?: (available: boolean) => void;
}>) {
  const { createBasket } = useCreateBasket();

  return (
    <PayPalExpressCheckoutBase
      price={ price }
      createBasket={ createBasket }
      onSuccess={ onSuccess }
      onError={ onError }
      onAvailabilityChange={ onAvailabilityChange }
    />
  );
}
